import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=5c40b19e&scoped=true"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40b19e",
  null
  
)

export default component.exports